module.exports = __webpack_public_path__ + "static/img/3.8a88a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/3.jpg
// module id = 6CoQ
// module chunks = 0